import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Container } from 'react-bootstrap';
import * as api from '~/Services/Service';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Loading from '~/Components/Loading';
import FiltrosRelatorio from './FiltrosRelatorio';
import TimelineProspectos from './TimelineProspectos';
import SecaoImobiliaria from './SecaoImobiliaria';

const RelatorioProspectosPastas = function() {
  const [dados, setDados] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [opcoesEmpreendimentos, setOpcoesEmpreendimentos] = useState([]);

  useEffect(function() {
    var carregarOpcoes = function() {
      api.obterEmpreendimentosProspectosPastas()
        .then(function(emps) {
          setOpcoesEmpreendimentos(emps);
        })
        .catch(function() {
          toast.error('Erro ao carregar empreendimentos.');
        });
    };
    carregarOpcoes();
  }, []);

  const handleSubmit = function(values) {
    if (!values.codigo_familia) {
      toast.warn('Por favor selecione um empreendimento.');
      return;
    }
    setIsLoading(true);
    setDados(null);

    const filtros = {
      codigo_familia: values.codigo_familia,
      data_inicial: values.data_inicial || null,
      data_final: values.data_final || null,
    };

    api.consultarRelatorioProspectosPastas(filtros)
      .then(function(response) {
        setDados(response);
      })
      .catch(function(err) {
        toast.error((err && err.message) || 'Erro ao consultar relatorio.');
      })
      .finally(function() {
        setIsLoading(false);
      });
  };

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul title="Cadastros / Pastas" />

      <FiltrosRelatorio
        onSubmit={handleSubmit}
        isLoading={isLoading}
        opcoesEmpreendimentos={opcoesEmpreendimentos}
      />

      {isLoading && <Loading label="Carregando relatorio" />}

      {dados && (
        <>
          <TimelineProspectos
            dados={dados.resumo}
            isPesquisa={dados.is_pesquisa}
            principal
          />

          {dados.imobiliarias && dados.imobiliarias.map(function(imob, index) {
            return (
              <SecaoImobiliaria
                key={imob.codigo_gerente || index}
                imobiliaria={imob}
                isPesquisa={dados.is_pesquisa}
                index={index}
              />
            );
          })}
        </>
      )}
    </Container>
  );
};

export default RelatorioProspectosPastas;
